import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProductClientDetails from './ProductClientDetails';
import { useProductById } from '../../../hooks/useProduct';

const ProductClientOnboarding = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    search: '',
    status: 'todo',
    page: 1,
    sortKey: '',
    sortDirection: 'asc'
  });

  const { data: productData, isLoading } = useProductById(productId);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      page: 1
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleSort = (key) => {
    setFilters(prev => ({
      ...prev,
      sortKey: key,
      sortDirection: prev.sortKey === key && prev.sortDirection === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleView = (id) => {
    navigate(`/products/onboarding-progress/${id}`);
  };

  return (
    <ProductClientDetails
      productName={productData?.productName}
      clients={productData?.clients || []}
      totalCount={productData?.totalCount || 0}
      totalPages={productData?.totalPages || 0}
      page={filters.page}
      status={filters.status}
      onPageChange={handlePageChange}
      onFilterChange={handleFilterChange}
      onView={handleView}
      onSort={handleSort}
      sortConfig={{
        key: filters.sortKey,
        direction: filters.sortDirection
      }}
      productData={productData}
    />
  );
};

export default ProductClientOnboarding; 